export default {
    tiposDoc: [],
    tiposSolicitud: [],
    dependenciasSolicitud: [],
    infoSolicitudPQRS: null,
    summaryPQRS: '',
}